import React from 'react'
import {InputAdornment, SxProps, TextField, Theme} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import {CONTROL_HEIGHT, NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface SearchBarProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  fullWidth?: boolean
  sx?: SxProps<Theme>
}

export default function SearchBar({
  value,
  onChange,
  placeholder = 'Cerca…',
  fullWidth,
  sx,
}: SearchBarProps): JSX.Element {
  return (
    <TextField
      size="small"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      fullWidth={fullWidth}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{color: NEUTRAL_SCALE[500]}} />
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          height: CONTROL_HEIGHT,
          borderRadius: '8px',
          backgroundColor: '#fff',
          '& fieldset': {borderColor: NEUTRAL_SCALE[200]},
          '&:hover fieldset': {borderColor: NEUTRAL_SCALE[300]},
          '&.Mui-focused fieldset': {borderColor: 'primary.main'},
        },
        ...sx,
      }}
    />
  )
}
